import axiosInstance from '@/utils/api.js'

var state = {
  dhcpOptions: []
}

var getters = {
  DHCP_OPTIONS: (state) => {
    return state.dhcpOptions
  }
}

var mutations = {
  SET_DHCP_OPTIONS: (state, payload) => {
    state.dhcpOptions = payload
  }
}

var actions = {
  GET_DHCP_OPTIONS: async (context, payload) => {
    let result = await axiosInstance.get('/inventory/dhcp_options?type=' + payload.type + '&owner_id=' + payload.id)
    if (result.status === 200) {
      context.commit('SET_DHCP_OPTIONS', result.data)
    }
  },
  CREATE_DHCP_OPTIONS: (context, payload) => {
    return axiosInstance.post('/inventory/dhcp_options', payload)
  },
  DELETE_DHCP_OPTIONS: (context, payload) => {
    return axiosInstance.delete('/inventory/dhcp_options?type=' + payload.type + '&owner_id=' + payload.id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/inventory/dhcpOptions.js